// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import querystring from 'querystring';
import React, { useContext } from 'react';
import { Link, RouteProps, useHistory, Redirect } from 'react-router-dom';
import MemberContext from '../../contexts/MemberContext';
import ResetPasswordForm from './ResetPasswordForm';
import ErrorImg from '../../assets/images/pic_error_internet.svg';
import PlantImage from './assets/plant-success.png';
import LogoImage from '../../assets/images/login-logo.svg'
import Center from '../../components/Center';
import S from './styles';
import { getQueryParams, useQuery } from '../../lib/utility';
import { FormattedMessage, useIntl } from 'react-intl';
function getToken(hash: string) {
  return hash
    .split('&')
    .map((chunk) => {
      const split = chunk.split('=');
      return {
        [split[0].replace('#', '')]: split[1]
      };
    })
    .reduce((pre, now) => ({ ...pre, ...now }), {});
}
interface ResetPasswordResult {
  resetType: 'success' | 'failed';
}
const ResetPasswordResult = (props: ResetPasswordResult): JSX.Element => {
  const { resetType } = props;
  const history = useHistory();
  const intl = useIntl();
  return (
    <S.LoginLayout>
      <S.ResultWrapper>
        <S.ResultImg src={resetType === 'success' ? PlantImage : ErrorImg} alt="" />
        <S.ResultDescriptionWrapper>
          <S.ResultTitle>{resetType === 'success' ? intl.formatMessage({ id: 'J060' }) : intl.formatMessage({ id: 'J057' })}</S.ResultTitle>
          <S.ResultDescription>
            {resetType === 'success' ? intl.formatMessage({ id: 'J061' }) : intl.formatMessage({ id: 'J058' })}
          </S.ResultDescription>
        </S.ResultDescriptionWrapper>
        {resetType === 'success' ?
          <S.ResultButton as={Link} to={'/login'}>{intl.formatMessage({ id: 'J062' })}</S.ResultButton> :
          <S.ResultButton onClick={() => { history.goBack() }}>{intl.formatMessage({ id: 'J059' })}</S.ResultButton>
        }
      </S.ResultWrapper>
    </S.LoginLayout>
  )
}
const ResetPasswordPage = (props: RouteProps): JSX.Element => {
  const { reset } = getQueryParams(useQuery());
  const member = useContext(MemberContext);
  const intl = useIntl();
  if (member.isLogin) {
    return (
      <Redirect to="/home"></Redirect>
    )
  }
  if (props.location?.hash) {
    console.log(querystring.parse(props.location.hash));
    const token = getToken(props.location.hash);
    console.log(token);
    console.log(token.id_token);
  }

  if (reset === 'success') {
    return <ResetPasswordResult resetType={'success'} />
  } else if (reset === 'failed') {
    return <ResetPasswordResult resetType={'failed'} />
  } else {
    return (
      <S.LoginLayout>
        <S.Container>
          <Center>
            <S.HeaderContainer>
              <S.Logo src={LogoImage} />
              <S.Title>{intl.formatMessage({ id: 'J051' })}</S.Title>
              <S.SubTitle>
                {intl.formatMessage({ id: 'J052' })}
              </S.SubTitle>
            </S.HeaderContainer>
          </Center>
          <S.ResetPasswordFormContainer>
            <ResetPasswordForm />
          </S.ResetPasswordFormContainer>
        </S.Container>
      </S.LoginLayout>
    );
  }
}
export { ResetPasswordPage as default }
